import { IVehicleLastOwnersHistory } from '~/shared';
import { TextLabel } from '../TextLabel';
import { StyledContainer, StyledTable, StyledTr } from './History.styled';

const History = ({
	history,
	duplicate,
}: {
	history?: IVehicleLastOwnersHistory[];
	duplicate?: boolean;
}) => {
	return (
		<StyledContainer>
			<StyledTable>
				<thead>
					<tr>
						<th>Владелец</th>
						<th>Дата покупки</th>
						<th>Пробег</th>
					</tr>
				</thead>
				<tbody>
					{history?.map((item, index) => (
						<StyledTr key={index}>
							<td>
								<TextLabel $size={14} $fw={500}>
									{item.ownerNickname}
								</TextLabel>
							</td>
							<td>
								<TextLabel $size={14} $fw={500}>
									{item.createdAt}
								</TextLabel>
							</td>
							<td>
								<TextLabel $size={14} $fw={500}>
									{item?.mileage?.toLocaleString('ru-RU')}&nbsp;
									<span style={{ fontWeight: 400, opacity: 0.5 }}>км.</span>
								</TextLabel>
							</td>
						</StyledTr>
					))}
				</tbody>
			</StyledTable>
			{duplicate && (
				<TextLabel
					style={{ marginTop: 27, textAlign: 'center' }}
					$size={16}
					$color={'rgba(0, 0, 0, 0.25)'}
				>
					Документы являются дубликатом
				</TextLabel>
			)}
		</StyledContainer>
	);
};

export { History };
